import React from 'react';
import { ReactEditor, useFocused, useSlateStatic } from 'slate-react';

import HelptapEditor from '../../helpers';

function Placeholder(props) {

  const editor = useSlateStatic();
  const focused = useFocused();

  function tryRenderPlaceholder() {

    if (focused !== true || HelptapEditor.isPathFocused(editor, ReactEditor.findPath(editor, props.element)) !== true) {
      return;
    }

    if (HelptapEditor.isEmptyNode(props.element) === false) {
      return;
    }

    const placeholderAttributes = {
      contentEditable: false,
      className: 'editor-placeholder'
    };

    return <div {...placeholderAttributes}>
      <span>{props.placeholder}</span>
    </div>;

  }

  function renderMain() {

    return <React.Fragment>
    	{tryRenderPlaceholder()}
    </React.Fragment>;

  }

  return renderMain();

}

export default Placeholder;